<template>
    <span>
        <slot name="dialog-activator" :treatmentBreakDialog="treatmentBreakDialog">
            <b-confirm
                text="Are you sure you want to update this treatment break record?"
                title="Update Treatment Break"
                @true="treatmentBreakDialog = true"
            >
                <template #button="{ on, dialog }">
                    <v-btn
                        icon
                        fab
                        x-small
                        rounded
                        outlined
                        color="primary"
                        class="mr-2"
                        :disabled="disabled"
                        v-on="on"
                        @click="dialog = true"
                    >
                        <v-icon dark small> mdi-pencil</v-icon>
                    </v-btn>
                </template>
            </b-confirm>
        </slot>
        <v-dialog v-model="treatmentBreakDialog" width="500" @click:outside="cancel()">
            <v-card>
                <v-form v-if="treatmentBreak" ref="treatmentBreakForm">
                    <v-card-title>{{ t('patients::dispensing.modal.title.treatment_break') }}</v-card-title>
                    <v-card-text>
                        <v-menu
                            v-model="menu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        >
                            <template #activator="{}">
                                <v-text-field
                                    v-model="treatmentBreak.input_date"
                                    dense
                                    rounded
                                    outlined
                                    background-color="#fff"
                                    :error-messages="errors.input_date"
                                    @click="menu = !menu"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="treatmentBreak.input_date"
                                :rules="validation.input_date"
                                @change="menu = false"
                            >
                            </v-date-picker>
                        </v-menu>

                        <v-textarea
                            v-model="treatmentBreak.reason"
                            dense
                            outlined
                            rounded
                            rows="3"
                            :label="'*' + t('patients::dispensing.form.label.reason')"
                            :rules="validation.reason"
                            :error-messages="errors.reason"
                        ></v-textarea>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="primary" text outlined rounded @click="cancel()">{{
                            t('default::button.close')
                        }}</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn v-show="changed" color="primary" outlined rounded @click="save()">{{
                            t('default::button.save')
                        }}</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
    </span>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            required: true,
        },
        patientId: {
            type: String,
            required: true,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            menu: false,
            treatmentBreak: this.initialData(),
            treatmentBreakDialog: false,
            validation: {
                input_date: [(v) => !!v || t('users::validation.field.required')],
                reason: [(v) => !!v || t('users::validation.field.required')],
            },
            errors: {
                input_date: null,
                reason: null,
            },
        };
    },
    computed: {
        changed() {
            return this.item.memo_date !== this.treatmentBreak.input_date;
        },
    },
    methods: {
        initialData() {
            return {
                id: this.item.id,
                input_date: this.item.memo_date,
                reason: this.item.memo_text,
            };
        },
        save() {
            if (!this.$refs.treatmentBreakForm.validate()) {
                return;
            }

            axios
                .post(
                    route('api.v1.patients.dispensing-treatment-breaks.update', {
                        patient: this.patientId,
                        treatment_break: this.item.related_record_id,
                    }),
                    this.treatmentBreak
                )
                .then(() => {
                    this.treatmentBreakDialog = false;
                    this.$emit('success', this.item);
                })
                .catch((error) => {
                    this.errors = error.response.data.errors;
                    _.each(error.response.data.errors, (fieldErrors) => {
                        this.errors[fieldErrors.field] = fieldErrors.errors[0];
                    });
                });
        },
        cancel() {
            this.treatmentBreak = this.initialData();
            this.treatmentBreakDialog = false;
            this.$emit('close');
        },
    },
};
</script>

<style scoped></style>
